import { Box, styled } from '@mui/material';

export const ChartInfoContainer = styled(Box)<{ noBorder?: boolean; margin?: string }>`
  display: flex;
  width: 100%;
  padding: 20px;
  justify-content: space-between;
  border-radius: 10px;

  border: ${({ noBorder }) => (noBorder ? 'none' : '1px solid #e3e3e3')};
  margin: ${({ margin }) => margin || '0'};

  @media (max-width: 768px) {
    p {
      font-size: 1.1rem;
    }
  }
`;

export const DescContainer = styled(Box)<{ gap?: number; margin?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ gap }) => (gap ? `${gap}px` : '0')};
  margin: ${({ margin }) => margin || '0'};
`;

export const StyledDot = styled(Box)<{ height?: string; width?: string; bgcolor: string }>`
  height: ${({ height }) => height || '16px'};
  width: ${({ width }) => width || '16px'};
  border-radius: 50%;
  background: ${({ bgcolor }) => bgcolor};
`;
